<template>
  <div class="main-contents-adm">
    <!-- 상단 타이틀 영역 -->
    <div class="tit">
      IT프로 회원정보 검색
      <div class="sub-title">전문분야 및 핵심역량 기반 검색</div>
    </div>

    <!-- 검색 영역 -->
    <div class="search-box special">
      <!-- 개인정보 검색 영역 -->
      <div class="search-row">
        <div class="search-label">개인정보</div>
        <div class="search-content">
          <SelectComp
            tagName="div"
            class="wd06"
            title="검색조건"
            v-model="input.searchType"
            :list="searchType"
            defValue="NAME"
          />
          <InputComp
            :title="searchType[input.searchType]"
            v-model="input.searchTxt"
            @keydown.enter="getList('1')"
          />
        </div>
      </div>
      
      <!-- 전문분야 검색 -->
      <div class="search-row">
        <div class="search-label">전문분야</div>
        <div class="search-content">
          <SelectComp
            tagName="div"
            class="wd03"
            title="전문업종 선택"
            v-model="input.specialtyType"
            cdId="PRO105"
            :isAll="true"
          />
          <SelectComp
            tagName="div"
            class="wd05"
            title="상세 전문분야 선택"
            :filter="input.specialtyType"
            v-model="input.detailSpecialtyType"
            cdId="PRO143"
            :isAll="true"
          />
        </div>
      </div>
      
      <!-- 핵심역량 검색 -->
      <div class="search-row">
        <div class="search-label">핵심역량<br/>(관리자 평가)</div>
        <div class="search-content">
          <div class="skill-input-wrap">
            <InputComp
              v-model="skillKeyword"
              placeholder="키워드 입력하기"
              @keydown.enter="addSkill"
              class="keyword-input"
            />
            <button class="btn-add" @click="addSkill">추가</button>
            <span class="skill-comment">※ 최대 4개까지 검색 가능</span>
          </div>
          <div class="skill-tags">
            <div class="skill-tag" v-for="(skill, index) in skills" :key="index">
              {{ skill }}
              <span class="tag-remove" @click="removeSkill(index)">×</span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="search-row">
        <div class="search-label">직무분야</div>
        <div class="search-content">
          <div class="tech-search-container">
            <div :class="[searchFlag ? 'btn open' : 'btn']" @click="openSearch()">직무분야 찾기</div>
            <!-- 닫힌 상태에서는 open class를 삭제 해주세요 -->
            <div :class="[searchFlag ? 'container' : 'container displayNone']">
              <div class="select-area">
                <ul>
                  <li v-for="(code, index) in searchCodeList" :key="index">
                    <a :class="[index == searchClick ? 'active' : [code.count > 0 ? 'activated':'']]" @click="changeClick(index)">{{code.cdNm}}</a>
                  </li>
                </ul>
              </div>
              <div class="result-area" v-if="searchClick == undefined">
                <div style="width:100%; height:100%; display:flex; justify-content:center; align-items:center;">  
                  <div><p> &lt; 직무분야를 선택하세요 </p></div>
                </div>
              </div>
              <div class="result-area" v-else>
                <ul>
                  <li v-for="(deta, index) in searchCodeList[searchClick].detailList" :key="index">
                    <a :class="[deta.checked ? 'active' : '']" @click="clickDetail(deta, index)">{{deta.cdNm}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 선택된 직무분야 태그 표시 영역 -->
      <div class="keywords-display" v-if="input.searchFilterList.length > 0">
        <div class="keywords-container">
          <div class="keyword-tag" v-for="(keyword, index) in input.searchFilterList" :key="index">
            <span>{{ keyword.cdNm.split(' > ')[0] }} > {{ keyword.cdNm.split(' > ')[1] }}</span>
            <button class="tag-close" @click="delDetail(keyword, index)">X</button>
          </div>
          <div class="refresh-container">
            <button class="refresh-button" @click="resetSearchFilter()" v-if="input.searchFilterList.length > 0">
              <span>초기화</span>
            </button>
          </div>
        </div>
      </div>
      
      <div class="search-btn-wrap">
        <div class="search-btn" @click="getList('1')">
          <img 
            src="/images/search_btn.png"/>
        </div>
      </div>
    </div>

    <div class="list-title">
      <div class="title-text">회원 목록</div>
      <div class="title-info">[{{ pageInfo.pageIndex || 1 }}/{{ Math.ceil(total/pageInfo.pageUnit) || 1 }} 페이지]</div>
      <div class="title-info"> [총 회원수 {{totalMembers}}명] [검색결과 {{total}}건] </div>
      <!-- 회원목록 다운로드 버튼 -->
      <div class="humaninfo-box2">
        <div class="image-button-container" @click="memberListDown()">
          <img 
            src="/images/resume_download_01.png"
            style="cursor: pointer;"
          />
          <span class="button-text">상세 정보 엑셀 다운로드</span>
        </div>
      </div>
    </div>

    <!-- 회원 목록 -->
    <div class="Board type3">
      <table class="Board_type3 admin special">
        <colgroup>
          <col width="3%">
          <col width="3%">
          <col width="5%">
          <col width="7%">
          <col width="8%">
          <col width="5%">
          <col width="6%">
          <col width="8%">
          <col width="8%">
          <col width="25%">
          <col width="10%">
        </colgroup>
        <thead>
          <tr>
            <th><input type="checkbox" :checked="selectAll" @click="toggleSelectAll"></th>
            <th>NO</th>
            <th>이름</th>
            <th>아이디</th>
            <th>연락처</th>
            <th>나이</th>
            <th>경력</th>
            <th>최종기술등급</th>
            <th>평균평가등급</th>
            <th>핵심역량(관리자평가)</th>
            <th class="resume">IT프로 종합정보</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="list && list.length > 0">
            <tr v-for="(member, index) in list" :key="member.mberSeq">
              <td class="score">
                <input type="checkbox" :value="member.mberSeq" v-model="selectedItems">
              </td>
              <td class="score">
                {{ pageInfo.pageUnit * (pageInfo.pageIndex - 1) + index + 1 }}
              </td>
              <td class="score">{{ formatEmptyValue(member.mberNm) }}</td>
              <td class="score">{{ formatEmptyValue(member.mberId) }}</td>
              <td class="score">{{ formatPhoneNumber(member.hpNo) }}</td>
              <td class="score">{{ formatEmptyValue(member.age, '세') }}</td>
              <td class="score">{{ formatCareerPeriod(member.careerPeriod) }}</td>
              <td class="score">{{ formatEmptyValue(member.techGradeNm) }}</td>
              <td class="score">{{ formatEmptyValue(member.avgGrade) }}</td>
              <td class="score">{{ formatEmptyValue(member.coreSkills) }}</td>
              <td class="score resume">
                <div class="btn" @click="viewResume(member)">정보보기 &#9654;</div>
              </td>
            </tr>
          </template>
          <tr v-else>
            <!-- 관련내용 없을 경우 -->
            <td colspan="11" class="none">검색된 IT프로 회원이 없습니다.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 페이징부분 -->
    <paging-comp :pageInfo="pageInfo" @page-click="goPage" />
  </div>
</template>

<script>
import pagingComp from "@/components/PagingComp.vue";
import InputComp from "@/components/base/InputComp.vue";
import SelectComp from "@/components/base/SelectComp.vue";

export default {
  components: { pagingComp, InputComp, SelectComp },
  data() {
    return {
      input: {
        memberType: "",
        searchType: "NAME",
        searchTxt: "",
        searchOption1: false,
        pageIndex: 1,
        specialtyType: "",
        detailSpecialtyType: "",
        jobField: "",
        searchFilterList: [] // 직무분야 선택 목록
      },
      skillKeyword: "",
      skills: [],
      selectedItems: [],     // 현재 페이지에서 선택된 회원 ID
      allSelectedItems: {},  // 모든 페이지에서 선택된 회원 정보
      selectAll: false, // 전체 선택 체크박스 상태
      selectAllProjects: false, // 프로젝트 전체 선택 체크박스 상태
      selectedProjects: [], // 프로젝트 리스트 선택 항목
      list: [],
      pageInfo: {},
      total: 0,
      totalMembers: 0,
      searchType: { NAME: "IT프로명", ID: "아이디", HP: "연락처" },
      searchCodeList: [], // 직무분야 코드 목록
      searchClick: undefined, // 선택된 직무분야 카테고리 인덱스
      searchFlag: false // 직무분야 드롭다운 표시 여부
    };
  },
  watch: {
    selectedItems: {
      handler() {
        this.updateSelectedItems();
      // 모든 항목이 선택되었는지 확인하여 selectAll 상태 업데이트
        this.selectAll = this.list.length > 0 && this.selectedItems.length === this.list.length;
      },
      deep: true
    }
  },

  beforeMount() {
    // 라우트 파라미터 처리
    const keys = Object.keys(this.input);
    for (const key in this.$route.params) {
      if (keys.indexOf(key) >= 0) {
        this.input[key] = this.$route.params[key];
      }
    }
    
    // 라우트 파라미터가 없으면 기본값 설정
    if (!this.input.searchTxt || this.input.searchTxt.trim() === '') {
      this.input.searchType = 'NAME';
    }

    // 직무분야 코드 목록 가져오기
    this.getCodeList();
    // 초기 데이터 로드
    this.getList();
  },
  methods: {
    getList(div, isScroll = false) {
      if (div) this.input.pageIndex = 1;
      
      // 스킬 키워드 입력값 추가
      // const searchParams = {
      //   ...this.input,
      //   skills: this.skills.join(','), // 서버 API 형식에 맞게 조정
      //   pageIndex : this.input.pageIndex,
      // };

      // var searchParams = {
      //   input : this.input,
      //   skills : this.skills.join(','), // 서버 API 형식에 맞게 조정
      //   pageIndex : this.input.pageIndex,
      // }

      var searchParams = this.input;
      searchParams.skills = this.skills.join(','); // 서버 API 형식에 맞게 조정
      searchParams.pageIndex = this.input.pageIndex;
      searchParams.getTotalCount = true;
      


      this.$.httpPost("/api/mem/adm/tec/getMemberList", searchParams)
        .then((res) => {
          if (res.data) {
          // console.log(res.data);
            this.list = res.data.list || [];
            this.pageInfo = res.data.pageInfo || {};
            this.total = res.data.total || 0;
            this.totalMembers = res.data.totalMembers || 0;
            
            // 페이지 로드 후 선택된 회원 업데이트
            this.updatePageSelectedItems();
            
            if (isScroll) {
              window.scroll(0, 0);
            }
          }
        })
        .catch((error) => {
          console.error("데이터 로드 오류:", error);
          this.$.httpErrorCommon(error);
        });
    },
    // 직무분야 코드 목록 가져오기
    getCodeList() {
      // 직무분야 코드 목록 API 호출
      this.$.httpPost('/api/mem/srh/getSearchCodeList', {})
        .then(res => {
          this.searchCodeList = res.data.codeList;
        })
        .catch(this.$.httpErrorCommon);
    },
    goPage(page) {
      this.input.pageIndex = page;
      
      // 페이지 이동 전 현재 페이지 선택 정보 저장
      this.updateSelectedItems();
      
      // 데이터 로드
      this.getList();
    },
    viewResume(item) {
      const query = { tecMberSeq: item.mberSeq };
      const params = {
        caller: {
          name: this.$route.name,
          params: this.input,
        },
      };
      this.$router.push({ name: "MEM912M02", query, params });
    },
    // 스킬 관련 메서드
    addSkill() {
      if (!this.skillKeyword || !this.skillKeyword.trim()) return;
      
      if (this.skills.length >= 4) {
        alert("최대 4개까지만 추가할 수 있습니다.");
        return;
      }
      
      if (!this.skills.includes(this.skillKeyword.trim())) {
        this.skills.push(this.skillKeyword.trim());
      }
      
      // 입력 필드 초기화
      this.skillKeyword = "";
    },
    removeSkill(index) {
      if (index >= 0 && index < this.skills.length) {
        this.skills.splice(index, 1);
      }
    },
    // 직무분야 관련 메서드 
    openSearch() {
      this.searchFlag = !this.searchFlag;
    },
    changeClick(idx) {
      this.searchClick = idx;
    },
    allCheck(deta) {
      for(let idx=0; idx < this.input.searchFilterList.length; idx++) {
        if(deta.cd == this.input.searchFilterList[idx].cd.substr(0,2)) {
          const cd = Number(deta.cd);
          this.searchCodeList[cd-1].count--;
          this.searchCodeList[cd-1].detailList[this.input.searchFilterList[idx].detaIndex].checked = false;
          this.input.searchFilterList.splice(idx,1);
          idx--;
        }
      }
    },
    clickDetail(deta, idx) {
      if(deta.checked == undefined || deta.checked == false) {
        if(deta.cd.length == 2) {
          this.allCheck(deta, idx);
        } else if(this.searchCodeList[Number(deta.cd.substr(0,2))-1].detailList[0].checked) {
          for(let checkIdx in this.input.searchFilterList) {
            if(deta.cd.substr(0,2) == this.input.searchFilterList[checkIdx].cd) {
              this.searchCodeList[Number(deta.cd.substr(0,2))-1].count--;
              this.searchCodeList[Number(deta.cd.substr(0,2))-1].detailList[0].checked = false;
              this.input.searchFilterList.splice(checkIdx,1);
            }
          }
        }

        if(this.input.searchFilterList.length > 14) {
          alert("직무분야는 최대 '15개' 까지 선택 가능합니다.");
          return;
        }

        const list = {...deta};
        list.cdNm = this.searchCodeList[this.searchClick].cdNm + " > " + deta.cdNm;
        list.detaIndex = idx;
        deta.checked = true;
        this.input.searchFilterList.push(list);

        if(isNaN(this.searchCodeList[this.searchClick].count) || this.searchCodeList[this.searchClick].count == 0) {
          this.searchCodeList[this.searchClick].count = 1;
        } else {
          this.searchCodeList[this.searchClick].count++;
        }
      } else {
        deta.checked = false;
        this.searchCodeList[this.searchClick].count--;
        for(let li = 0; li < this.input.searchFilterList.length; li++) {
          if(this.input.searchFilterList[li].cd == deta.cd) {
            this.input.searchFilterList.splice(li,1);
            break;
          }
        }
      }   
    },
    delDetail(list, idx) {
      const cd = Number(list.cd.substr(0,2));
      this.searchCodeList[cd-1].count--;
      this.searchCodeList[cd-1].detailList[list.detaIndex].checked = false;
      this.input.searchFilterList.splice(idx,1);
    },
    resetSearchFilter() {
      for(const list of this.input.searchFilterList) {
        const cd = Number(list.cd.substr(0,2));
        this.searchCodeList[cd-1].count--;
        this.searchCodeList[cd-1].detailList[list.detaIndex].checked = false;
      }
      this.input.searchFilterList.splice(0, this.input.searchFilterList.length);
    },
    memberListDown() {
  // 현재 페이지 선택 상태 업데이트
  this.updateSelectedItems();
  
  // 선택된 회원 수 확인
  const selectedMemberCount = Object.keys(this.allSelectedItems).length;
  
  // 다운로드 실행 함수
  const executeDownload = (mode) => {
    let param = {};
    
    if (mode === 'all') {
      // ① 체크박스 미선택 시: 전체 회원 다운로드
      param = {
        downloadAll: true,  // 서버에 전체 다운로드 요청임을 명확히 전달
        searchParams: { ...this.input, skills: this.skills.join(',') },
        useCustomTemplate: true,
        templateName: 'adminIT프로검색 출력 데이터.xlsx'
      };
    } else if (mode === 'currentPage') {
      // ③ 현재 페이지의 모든 회원 다운로드
      param = {
        memberList: this.list,
        useCustomTemplate: true,
        templateName: 'adminIT프로검색 출력 데이터.xlsx'
      };
    } else {
      // ② 선택된 회원만 다운로드
      param = {
        memberList: Object.values(this.allSelectedItems),
        useCustomTemplate: true,
        templateName: 'adminIT프로검색 출력 데이터.xlsx'
      };
    }
    
    this.$.fileDownload('/api/mem/adm/tec/getMemberListFileDown', param)
      .then(() => {
        // 다운로드 성공
      })
      .catch(err => {
        alert(err.response?.data?.error_description || "다운로드 중 오류가 발생했습니다.");
      });
  };
  
  if (selectedMemberCount === 0) {
    // ① 체크박스 미선택 시: 전체 회원 정보 다운로드 (확인 후)
    if (confirm("전체 회원정보가 다운로드 됩니다. 진행하시겠습니까?")) {
      executeDownload('all');
    }
  } else if (this.selectAll) {
    // ③ 전체 선택 체크박스 활성화 시: 현재 페이지 회원만 다운로드
    executeDownload('currentPage');
  } else {
    // ② 개별 체크박스 선택 시: 선택된 회원만 다운로드
    executeDownload('selected');
  }
},
    
    // 수정된 전체 선택 체크박스 토글 기능
    toggleSelectAll() {
      // 현재 테이블에 모든 항목이 선택된 상태인지 확인
      const isAllSelected = this.list.length > 0 && this.selectedItems.length === this.list.length;
  
      if (isAllSelected) {
    // 모든 항목이 이미 선택된 상태에서 클릭하면 모두 선택 해제
        this.selectedItems = [];
      } else {
    // 일부 또는 아무것도 선택되지 않은 상태에서 클릭하면 모두 선택
        this.selectedItems = this.list.map(item => item.mberSeq);
    }
  
    // 선택된 회원 정보 업데이트
    this.updateSelectedItems();
},

    // 체크박스 변경 이벤트 처리
    updateSelectedItems() {
      // 체크된 회원만 저장
      for (let i = 0; i < this.list.length; i++) {
        const member = this.list[i];
        const id = member.mberSeq;
        
        if (this.selectedItems.includes(id)) {
          // 현재 페이지에서 선택된 회원 저장
          this.allSelectedItems[id] = member;
        } else {
          // 현재 페이지에서 선택 해제된 회원 삭제
          delete this.allSelectedItems[id];
        }
      }
    },
    
    // 페이지 로드 시 selectedItems 업데이트
    updatePageSelectedItems() {
      // 현재 페이지 회원 ID 리스트
      const currentPageIds = this.list.map(item => item.mberSeq);
      
      // allSelectedItems에서 현재 페이지에 해당하는 회원 필터링
      const selectedIds = [];
      currentPageIds.forEach(id => {
        if (this.allSelectedItems[id]) {
          selectedIds.push(id);
        }
      });
      
      // 현재 페이지의 선택된 회원 업데이트
      this.selectedItems = selectedIds;
      
      // 전체 선택 체크박스 상태 업데이트
      this.selectAll = currentPageIds.length > 0 && selectedIds.length === currentPageIds.length;
    },
    // 빈 값 처리 메서드
    formatEmptyValue(value, suffix = '') {
      if (value === null || value === undefined || value === '' || value === 'null') {
        return '-';
      }
      return suffix ? value + suffix : value;
    },
    // 경력 기간 포맷팅 메서드
    formatCareerPeriod(value) {
      if (value === null || value === undefined || value === '' || value === 'null') {
        return '-';
      }
      
      // 이미 포맷된 문자열인 경우 ("N년 N개월" 형태)
      if (typeof value === 'string' && value.includes('년')) {
        const regex = /^(\d+)년\s*(\d+)개월$/;
        const match = value.match(regex);
        if (match) {
          const years = parseInt(match[1]);
          const months = parseInt(match[2]);
          const totalMonths = years * 12 + months;
          
          if (totalMonths < 12) {
            return totalMonths + '개월';
          } else {
            const newYears = Math.floor(totalMonths / 12);
            const newMonths = totalMonths % 12;
            return newYears + '년' + (newMonths > 0 ? ' ' + newMonths + '개월' : ' 0개월');
          }
        }
      }
      
      // 숫자인 경우 (월 단위)
      if (typeof value === 'number' || /^\d+$/.test(value)) {
        const months = parseInt(value);
        if (months < 12) {
          return months + '개월';
        } else {
          const years = Math.floor(months / 12);
          const remainingMonths = months % 12;
          return years + '년' + (remainingMonths > 0 ? ' ' + remainingMonths + '개월' : ' 0개월');
        }
      }
      
      // 기타 경우 원본 반환
      return value;
    },
    // 전화번호 포맷팅 메서드
    formatPhoneNumber(phoneNumber) {
      if (!phoneNumber || phoneNumber === 'null' || phoneNumber === '') return '-';
      
      // 숫자만 추출
      const numbers = phoneNumber.replace(/\D/g, '');
      
      // 길이에 따른 포맷팅
      if (numbers.length === 11) {
        // 010-0000-0000 형식
        return numbers.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
      } else if (numbers.length === 10) {
        // 02-0000-0000 또는 031-000-0000 형식
        if (numbers.startsWith('02')) {
          return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
        } else {
          return numbers.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        }
      } else if (numbers.length === 9) {
        // 02-000-0000 형식
        return numbers.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
      }
      
      // 기본적으로 원본 반환 (유효하지 않은 번호)
      return phoneNumber;
    },
    // 전체 프로젝트 선택 체크박스 토글 기능
    toggleSelectAllProjects() {
      if (this.selectAllProjects) {
        // 전체 선택 시 모든 프로젝트 ID 선택
        this.selectedProjects = this.tecMberList.map(project => project.projectSeq);
      } else {
        // 전체 선택 해제 시 모든 항목 선택 해제
        this.selectedProjects = [];
      }
    }
  },
};
</script>

<style>
/* admcontents.css 파일에 있는 스타일을 사용합니다. */
</style>